module.exports = __webpack_public_path__ + "img/exam.f292da85.png";